import BolsaFamiliaIndexPage from "@/Pages/BolsaFamilia/index.vue";
import { can } from "@/plugins/can";

export default [
  {
    path: "/bolsa-familia/",
    name: "bolsa-familia",
    component: BolsaFamiliaIndexPage,
    beforeEnter(to, from, next) {
      if (!can(["bolsaFamilia.*"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
